import React from "react";
import { withRouter } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Select,
  IconButton,
  Typography,
  Menu,
  MenuItem,
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import NewStoreDialog from "../Stores/NewStoreDialog";

// provider
import { useLayout } from  "../../providers/App/Layout/LayoutProvider";
import { useUser } from "../../providers/App/User/UserProvider";
import { useStore } from "../../providers/App/Store/StoreProvider";

const Header = ({history}) => {

  // global
  const { userInfo, signOut } = useUser();
  const { sidebarState } = useLayout();

  const classes = useStyles();

  // local
  const [profileMenu, setProfileMenu] = React.useState(null);
  const [newStoreDialogOpen, setNewStoreDialogOpen] = React.useState(false);
  const { storesList, storeState, setStoreState } = useStore();

  const handleChange = (event) => {
    if(event.target.value === -1){
      setNewStoreDialogOpen(true);
      return;
    }
    for(let index = 0; index<storesList.length; index+=1){
      if(storesList[index].id === event.target.value){
        setStoreState(storesList[index].id, storesList[index].name, storesList[index].base_url, storesList[index].api_key);
        return;
      }
    }
  };
  return (
    <>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            color="inherit"
            onClick={() => sidebarState.setIsSidebarOpened(!sidebarState.isSidebarOpened)}
            className={classNames(
              classes.headerMenuButton,
              classes.headerMenuButtonCollapse,
            )}
          >
            {sidebarState.isSidebarOpened ? (
              <ArrowBackIcon
                classes={{
                  root: classNames(
                    classes.headerIcon,
                    classes.headerIconCollapse,
                  ),
                }}
              />
            ) : (
              <MenuIcon
                classes={{
                  root: classNames(
                    classes.headerIcon,
                    classes.headerIconCollapse,
                  ),
                }}
              />
            )}
          </IconButton>
          <Typography variant="h6" weight="medium" className={classes.logotype}>
              <b>ReCan</b>
          </Typography>
          <div className={classes.grow} />
          <Select
            className={[classes.select, "bg-white"].join(" ")}
            variant="outlined"
            margin="dense"
            key={0}
            labelId="select_store_label"
            id="select_store"
            placeholder="Please Select"
            value={storeState.id}
            onChange={handleChange}
          >
            {
              storesList && storesList.map((item) => {
                return (
                  <MenuItem
                    key={item.id}
                    value={item.id}
                    label={item.name}
                  >
                    {item.name}
                  </MenuItem>
                );
              })
            }
            <MenuItem
              key={-1}
              value={-1}
              label="Create a Store"
            >
              Create a Store
            </MenuItem>
          </Select>
          <IconButton
            aria-haspopup="true"
            color="inherit"
            className={classes.headerMenuButton}
            aria-controls="profile-menu"
            onClick={e => setProfileMenu(e.currentTarget)}
          >
            <AccountIcon classes={{ root: classes.headerIcon }} />
          </IconButton>
          <Menu
            id="profile-menu"
            open={Boolean(profileMenu)}
            anchorEl={profileMenu}
            onClose={() => setProfileMenu(null)}
            className={classes.headerMenu}
            classes={{ paper: classes.profileMenu }}
            disableAutoFocusItem
          >
            <div className={classes.profileMenuUser}>
              <Typography variant="h4" weight="medium">
                {userInfo && userInfo.name}
              </Typography>
              <Typography
                className={classes.profileMenuLink}
                component="p"
                color="primary"
              >
                {userInfo && userInfo.email}
              </Typography>
            </div>
            <MenuItem
              className={classNames(
                classes.profileMenuItem,
                classes.headerMenuItem,
              )}
            >
              <AccountIcon className={classes.profileMenuIcon} /> Profile
            </MenuItem>
            <div className={classes.profileMenuUser}>
              <Typography
                className={classes.profileMenuLink}
                color="primary"
                onClick={signOut}
              >
                Sign Out
              </Typography>
            </div>
          </Menu>
        </Toolbar>
      </AppBar>
      <NewStoreDialog
        open={newStoreDialogOpen}
        handleClose={() => setNewStoreDialogOpen(false)}
      />
    </>
  );
};

export default withRouter(Header); 
